/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { NgModule } from '@angular/core'
import { PagesRoutingModule } from './pages-routing.module'

@NgModule({
  imports: [
    // Routing
    PagesRoutingModule,
  ],
})
export class PagesModule {}
